<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách hoa hồng Tingbox cho CTV</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="openImportModal"
          class="font-medium f12 btn btn-outline-secondary"
          v-if="
            dataPermission && dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_IMPORT_FILE')
          "
        >
          <i class="bx bx-plus-circle"></i> Nhập file
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          title="Gán CTV"
          style="width: 100px"
          :disabled="loadingExport"
          @click="exportExcel"
          v-if="
            dataPermission &&
            dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_EXPORT_EXCEL')
          "
        >
          <i class="bx bx-download"></i>
          {{ loadingExport ? 'Đang tải...' : 'Xuất file' }}
        </button>
        <!-- <button class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button> -->
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keyword"
              class="form-control f12 hc-37"
              placeholder="Từ khoá: serial, mail MC, Mã HĐ"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange1"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange4"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian huỷ
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              placeholder="Trạng thái thanh toán"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.userReceiveId"
              :options="optionUserReceive"
              :settings="searchUser"
              placeholder="Người hưởng"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.registrationType"
              :options="optionRegistrationType"
              placeholder="Loại ĐKKD"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange2"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian thanh toán
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange3"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian truy thu
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.type"
              :options="optionPaymentType"
              placeholder="Loại thanh toán"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.userSellId"
              :options="optionUserSell"
              :settings="searchUser"
              placeholder="Người bán TB"
            />
          </div>

          <div class="form-group form-group-action">
            <button
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header list_total">
                <TotalCount :totals="pagination.total" :data="listCount" />
              </div>
            </div>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTable"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="{ index }">
                <span style="cursor: pointer">
                  {{
                    pagination.page > 1
                      ? index + 1 + pagination.limit * (pagination.page - 1)
                      : index + 1
                  }}</span
                >
              </template>
              <template #cell(userReceive)="data">
                <div v-if="data.item.userReceive">
                  <b>{{ data.item.userReceive.name }}</b
                  ><br />
                  <a :href="`mailto:${data.item.userReceive.email}`">{{
                    data.item.userReceive.email
                  }}</a>
                </div>
              </template>

              <template #cell(userSell)="data">
                <div v-if="data.item.userSell">
                  <b>{{ data.item.userSell.name }}</b
                  ><br />
                  <a :href="`mailto:${data.item.userSell.email}`">{{ data.item.userSell.email }}</a>
                </div>
              </template>

              <template #cell(device)="data">
                <div>
                  <b><span style="color: gray">Tên: </span>{{ data.item.deviceCategory }}</b>
                  <br />
                  <span style="font-size: 12px; color: #999"> serial: {{ data.item.serial }}</span>
                </div>
              </template>

              <template #cell(status)="data">
                <span class="badge" :class="getStatusType(data?.item?.status)">
                  {{ getStatusLabel(data?.item?.status) }}
                </span>
              </template>

              <template #cell(merchantName)="data">
                <div>
                  <b><span style="color: gray">Tên: </span>{{ data.item.merchantName }}</b>
                  <br />
                  <b><span style="color: gray">Email: </span>{{ data.item.merchantEmail }}</b>
                  <br />
                  <span
                    class="badge mt-1"
                    :class="{
                      'badge-success': data.item.registrationType === 'REGISTERED',
                      'badge-danger': data.item.registrationType === 'UNREGISTERED',
                    }"
                  >
                    {{ data.item.registrationType === 'REGISTERED' ? 'Có ĐKKD' : 'Không ĐKKD' }}
                  </span>
                </div>
              </template>
              <template #cell(amount)="data">
                <div style="min-width: 100px">{{ data.item.amount?.toLocaleString() }} đ</div>
              </template>

              <template #cell(dateTime)="data">
                <div style="width: 190px">
                  <div v-if="data.item.createdTime" class="nowrap">
                    <span class="text-muted">Tạo:</span>
                    {{ data.item.createdTime | formatTime }}
                  </div>
                  <div v-if="data.item.cancelledTime" class="nowrap">
                    <span class="text-muted">Huỷ:</span>
                    {{ data.item.cancelledTime | formatTime }}
                  </div>
                  <div v-if="data.item.paidTime" class="nowrap">
                    <span class="text-muted">Thanh toán:</span>
                    {{ data.item.paidTime | formatTime }}
                  </div>
                  <div v-if="data.item.recoupmentTime" class="nowrap">
                    <span class="text-muted">Truy thu:</span>
                    {{ data.item.recoupmentTime | formatTime }}
                  </div>
                </div>
              </template>

              <template #cell(type)="data">
                <span
                  class="badge"
                  :class="{
                    'badge-primary': data.item.type === 'PAYMENT',
                    'badge-warning': data.item.type === 'RECOUPMENT',
                  }"
                >
                  {{ data.item.type === 'PAYMENT' ? 'Thanh toán' : 'Truy thu' }}
                </span>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #cell(action)="data">
                <b-dropdown variant="outline-light">
                  <b-dropdown-item @click="viewDetail(data.item.id)">
                    Xem chi tiết
                  </b-dropdown-item>

                  <!-- Chỉ hiện nút Hủy thanh toán khi status = PENDING_PAYMENT -->
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'PENDING_PAYMENT' &&
                      dataPermission &&
                      dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CANCEL')
                    "
                    @click="handleOpenModal(data.item, 'CANCEL_PAYMENT')"
                  >
                    Huỷ thanh toán
                  </b-dropdown-item>

                  <!-- Chỉ hiện nút Thanh toán xong khi status = PENDING_PAYMENT -->
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'PENDING_PAYMENT' &&
                      dataPermission &&
                      dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CONFIRM')
                    "
                    @click="handleOpenModal(data.item, 'MARK_PAID')"
                  >
                    <span>Thanh toán xong</span>
                  </b-dropdown-item>

                  <!-- Chỉ hiện nút Tạo truy thu khi status = PAID -->
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'PAID' &&
                      !data.item.isRecoupment &&
                      dataPermission &&
                      dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CREATE')
                    "
                    @click="handleOpenModal(data.item, 'CREATE_RECOUPMENT')"
                  >
                    <span>Tạo truy thu</span>
                  </b-dropdown-item>

                  <!-- Chỉ hiện nút Truy thu xong khi status = NEED_RECOUPMENT -->
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'NEED_RECOUPMENT' &&
                      dataPermission &&
                      dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CONFIRM')
                    "
                    @click="handleOpenModal(data.item, 'MARK_RECOUPED')"
                  >
                    <span>Truy thu xong</span>
                  </b-dropdown-item>

                  <!-- Chỉ hiện nút Hủy truy thu khi status = RECOUPED -->
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'NEED_RECOUPMENT' &&
                      dataPermission &&
                      dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CANCEL')
                    "
                    @click="handleOpenModal(data.item, 'CANCEL_RECOUPMENT')"
                  >
                    Huỷ truy thu
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-group class="mb-0 mr-3">
              <b-form-select
                v-model="pagination.limit"
                :options="pageOptions"
                @change="onItemsPerPageChange"
              ></b-form-select>
            </b-form-group>
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.total"
              :per-page="pagination.limit"
              class="mr-2 fl-right"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal xác nhận các thay đổi -->
    <ModalComfirm @onLoad="fetchData" ref="modalComfirm" />
    <ImportModal ref="importModal" @onLoad="fetchData" />
  </div>
</template>

<script>
  import moment from 'moment'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { SearchStaff } from '@/services/customer-support/staff'
  import ImportModal from './tingBoxCtv/ImportModal.vue'
  import ModalComfirm from './tingBoxCtv/ModalComfirm.vue'
  import { getListTingboxCtv, exportExcelCtv } from '@/services/tingbox-ctv'
  import TotalCount from '@/components/cskh/Counts.vue'
  import { showMess } from '@/config/utils'

  const fieldsTable = [
    { key: 'index', label: 'STT' },
    // { key: 'id', label: 'ID' },
    { key: 'userReceive', label: 'Người hưởng' },
    { key: 'type', label: 'Loại thanh toán' },
    { key: 'userSell', label: 'Người bán TB' },
    {
      key: 'device',
      label: 'Thiết bị',

      thStyle: { 'min-width': '150px' },
    },
    {
      key: 'merchantName',
      label: 'Merchant',
      thStyle: { 'min-width': '200px', width: '200px' },
    },
    { key: 'contractCode', label: 'Mã HĐ' },
    {
      key: 'amount',
      label: 'Số tiền',
      thStyle: { 'min-width': '100px', width: '100px' },
    },
    { key: 'status', label: 'Trạng thái' },
    {
      key: 'dateTime',
      label: 'Ngày',
      thStyle: { 'min-width': '200px', width: '200px' },
    },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    mixins: [prepareQueryParamsMixin],
    components: {
      ImportModal,
      ModalComfirm,
      TotalCount,
    },
    data() {
      return {
        localeData: Config.localeData,
        fieldsTable,
        filterTable: fieldsTable,

        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataTable: [],

        // loading
        loading: false,
        loadingModal: false,
        loadingExport: false,

        // modal
        openModal: false,
        infoModal: {},

        // list count
        totalCheck: {
          total: 0,
          totalPaid: 0,
          totalNeedRecoup: 0,
          totalRecoup: 0,
        },

        // seachUser
        searchUser: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                SearchStaff({
                  limit: 50,
                  // page: 1,
                  keyWord: keySearch,
                })
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item?.id,
                            text: (item?.name || item?.userName) ?? item?.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        // filter
        search: {
          keyword: '',
          userReceiveId: '',
          userSellId: '',
          type: '',
          status: '',
          registrationType: '',
          createdDateFrom: 0,
          createdDateTo: 0,
          paidDateFrom: 0,
          paidDateTo: 0,
          recoupmentDateFrom: 0,
          recoupmentDateTo: 0,
          canceledDateFrom: 0,
          canceledDateTo: 0,
        },

        // thời gian filter
        dateRange1: {
          startDate: null,
          endDate: null,
        },
        dateRange2: {
          startDate: null,
          endDate: null,
        },
        dateRange3: {
          startDate: null,
          endDate: null,
        },
        dateRange4: {
          startDate: null,
          endDate: null,
        },

        // lựa chọn người hưởng thụ
        optionUserReceive: [],

        // lựa chọn người bán thiết bị
        optionUserSell: [],

        // status
        optionStatus: [
          { id: 0, text: 'Tất cả' },
          {
            id: 'PENDING_PAYMENT',
            text: 'Chờ thanh toán',
            type: 'badge-warning',
          },
          {
            id: 'CANCELED',
            text: 'Đã huỷ',
            type: 'badge-danger',
          },
          {
            id: 'PAID',
            text: 'Đã thanh toán',
            type: 'badge-success',
          },
          {
            id: 'RECOUPED',
            text: 'Đã truy thu',
            type: 'badge-info',
          },
          {
            id: 'NEED_RECOUPMENT',
            text: 'Chờ truy thu',
            type: 'badge-info',
          },
        ],

        // đkkd
        optionRegistrationType: [
          { id: 0, text: 'Tất cả' },
          {
            id: 'REGISTERED',
            text: 'Có ĐKKD',
            type: 'success',
          },
          {
            // id: 'NOT_REGISTERED',
            id: 'UNREGISTERED',
            text: 'Không ĐKKD',
            type: 'danger',
          },
        ],

        // payment tyoe
        optionPaymentType: [
          { id: 0, text: 'Tất cả' },
          { id: 'PAYMENT', text: 'Thanh toán' },
          { id: 'RECOUPMENT', text: 'Truy thu' },
        ],
        // phân trang
        pagination: {
          total: 0,
          limit: 20,
          page: 1,
        },

        // danh sách tổng
        listCount: [],

        // Mốc trang,
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
      }
    },
    // gọi lại api để phân trang
    watch: {
      'pagination.page': function () {
        this.fetchData()
      },
    },

    // tải dữ liệu khi mới vào trang
    async mounted() {
      if (
        this.dataPermission &&
        this.dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_VIEW')
      ) {
        this.fetchData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },

    computed: {
      // tải quyền
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        // dataSearch: 'search/getDataSearchOther'
      }),

      // lấy type trạng thái
      getStatusType() {
        const statusMap = this.optionStatus.reduce((acc, curr) => {
          acc[curr.id] = curr
          return acc
        }, {})
        return type => {
          return statusMap[type]?.type || type
        }
      },

      // lấy label trạng thái
      getStatusLabel() {
        const statusMap = this.optionStatus.reduce((acc, curr) => {
          acc[curr.id] = curr
          return acc
        }, {})
        return type => {
          return statusMap[type]?.text || type
        }
      },
    },

    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        const date = new Date(ms) // tạo 1 lần để tránh tạo nhiều object Date

        return (
          String(date.getHours()).padStart(2, '0') +
          ':' +
          String(date.getMinutes()).padStart(2, '0') +
          ', ' +
          String(date.getDate()).padStart(2, '0') +
          '/' +
          String(date.getMonth() + 1).padStart(2, '0') +
          '/' +
          date.getFullYear()
        )
      },
    },

    methods: {
      // open modal inport
      openImportModal() {
        this.$refs.importModal.show()
      },

      // mốc trang
      onItemsPerPageChange() {
        this.pagination.page = 1
        this.removeForm()
      },

      // xuất file excel
      async exportExcel() {
        this.loadingExport = true
        try {
          const searchParams = this.filterEmptyValues({
            ...this.search,
            limit: this.pagination.limit,
            page: this.pagination.page,
          })
          const res = await exportExcelCtv(searchParams)
          res &&
            (() => {
              const href = URL.createObjectURL(res)
              // download QR
              const link = document.createElement('a')
              link.href = href
              link.setAttribute('download', 'download-tingbox-ctv.xlsx')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              URL.revokeObjectURL(href)
            })()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingExport = false
        }
      },

      // Update handleOpenModal method
      handleOpenModal(data, type) {
        this.$refs.modalComfirm.handleOpen(data, type)
      },

      // check filter
      filterEmptyValues(obj) {
        const filtered = {}
        // Kiểm tra và chuyển đổi dateRange1 (Thời gian tạo)
        if (this.dateRange1.startDate && this.dateRange1.endDate) {
          filtered.createdDateFrom = moment(this.dateRange1.startDate)
            .set({
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0,
            })
            .valueOf()
          filtered.createdDateTo = moment(this.dateRange1.endDate)
            .set({
              hours: 23,
              minutes: 59,
              seconds: 59,
              milliseconds: 999,
            })
            .valueOf()
        }

        // Kiểm tra và chuyển đổi dateRange2 (Thời gian thanh toán)
        if (this.dateRange2.startDate && this.dateRange2.endDate) {
          filtered.paidDateFrom = moment(this.dateRange2.startDate)
            .set({
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0,
            })
            .valueOf()
          filtered.paidDateTo = moment(this.dateRange2.endDate)
            .set({
              hours: 23,
              minutes: 59,
              seconds: 59,
              milliseconds: 999,
            })
            .valueOf()
        }

        // Kiểm tra và chuyển đổi dateRange3 (Thời gian truy thu)
        if (this.dateRange3.startDate && this.dateRange3.endDate) {
          filtered.recoupmentDateFrom = moment(this.dateRange3.startDate)
            .set({
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0,
            })
            .valueOf()
          filtered.recoupmentDateTo = moment(this.dateRange3.endDate)
            .set({
              hours: 23,
              minutes: 59,
              seconds: 59,
              milliseconds: 999,
            })
            .valueOf()
        }

        // Kiểm tra và chuyển đổi dateRange4 (Thời gian huỷ)
        if (this.dateRange4.startDate && this.dateRange4.endDate) {
          filtered.canceledDateFrom = moment(this.dateRange4.startDate)
            .set({
              hours: 0,
              minutes: 0,
              seconds: 0,
              milliseconds: 0,
            })
            .valueOf()
          filtered.canceledDateTo = moment(this.dateRange4.endDate)
            .set({
              hours: 23,
              minutes: 59,
              seconds: 59,
              milliseconds: 999,
            })
            .valueOf()
        }

        Object.keys(obj).forEach(key => {
          if (
            obj[key] !== 0 &&
            obj[key] !== '0' &&
            obj[key] !== '' &&
            obj[key] !== null &&
            obj[key] !== undefined
          ) {
            filtered[key] = obj[key]
          }
        })
        return filtered
      },
      // filterEmptyValues(obj) {
      //   const filtered = {}
      //   // Kiểm tra và chuyển đổi dateRange1 (Thời gian tạo)
      //   if (this.dateRange1.startDate && this.dateRange1.endDate) {
      //     filtered.createdDateFrom = moment(this.dateRange1.startDate)
      //       .startOf('day')
      //       .valueOf()
      //     filtered.createdDateTo = moment(this.dateRange1.endDate)
      //       .endOf('day')
      //       .valueOf()
      //   }

      //   // Kiểm tra và chuyển đổi dateRange2 (Thời gian thanh toán)
      //   if (this.dateRange2.startDate && this.dateRange2.endDate) {
      //     filtered.paidDateFrom = moment(this.dateRange2.startDate)
      //       .startOf('day')
      //       .valueOf()
      //     filtered.paidDateTo = moment(this.dateRange2.endDate)
      //       .endOf('day')
      //       .valueOf()
      //   }

      //   // Kiểm tra và chuyển đổi dateRange3 (Thời gian truy thu)
      //   if (this.dateRange3.startDate && this.dateRange3.endDate) {
      //     filtered.recoupmentDateFrom = moment(this.dateRange3.startDate)
      //       .startOf('day')
      //       .valueOf()
      //     filtered.recoupmentDateTo = moment(this.dateRange3.endDate)
      //       .endOf('day')
      //       .valueOf()
      //   }

      //   // Kiểm tra và chuyển đổi dateRange4 (Thời gian huỷ)
      //   if (this.dateRange4.startDate && this.dateRange4.endDate) {
      //     filtered.canceledDateFrom = moment(this.dateRange4.startDate)
      //       .startOf('day')
      //       .valueOf()
      //     filtered.canceledDateTo = moment(this.dateRange4.endDate)
      //       .endOf('day')
      //       .valueOf()
      //   }

      //   Object.keys(obj).forEach((key) => {
      //     if (
      //       obj[key] !== 0 &&
      //       obj[key] !== '' &&
      //       obj[key] !== null &&
      //       obj[key] !== undefined
      //     ) {
      //       filtered[key] = obj[key]
      //     }
      //   })
      //   return filtered
      // },

      // chuyển trang chi tiết
      viewDetail(id) {
        window.open(`/list-tingbox-ctv/${id}`)
      },

      // define ngày trên lịch
      transformDate() {
        this.search.createdDateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.createdDateTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },

      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },

      // Bỏ lọc
      async removeForm() {
        this.search = {
          keyword: '',
          userReceiveId: '',
          userSellId: '',
          type: '',
          status: '',
          registrationType: '',
          createdDateFrom: 0,
          createdDateTo: 0,
          paidDateFrom: 0,
          paidDateTo: 0,
          recoupmentDateFrom: 0,
          recoupmentDateTo: 0,
          canceledDateFrom: 0,
          canceledDateTo: 0,
        }
        this.dateRange1 = {
          startDate: null,
          endDate: null,
        }
        this.dateRange2 = {
          startDate: null,
          endDate: null,
        }
        this.dateRange3 = {
          startDate: null,
          endDate: null,
        }
        this.dateRange4 = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },

      // data bảng
      async fetchData() {
        this.loading = true
        try {
          const searchParams = this.filterEmptyValues({
            ...this.search,
            limit: this.pagination.limit,
            page: this.pagination.page,
          })
          const res = await getListTingboxCtv(searchParams)
          if (res.code === 1000) {
            this.dataTable = res.data?.list || []
            this.pagination.total = res.data?.count
            this.listCount =
              res.data?.countStatus.map(i => {
                return {
                  count: i.amount,
                  status: `Tổng ${this.getStatusLabel(i.status)}` || i.status,
                  status_class: this.getStatusType(i.status).replace('badge', 'text') || '',
                }
              }) || []
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
